import React from "react";

const doesNothing = () => {};

const DeleteIPRangeButton = ({ onClick = doesNothing }) => (
  <a className="action waves-effect borderless" onClick={onClick}>
    <i className="material-icons">delete</i>
  </a>
);

const IPRangeItem = ({
  id,
  address = "",
  deleted,
  even = false,
  onDelete = doesNothing,
}) => {
  if (deleted === true) {
    return null;
  }
  const doIPRangeDelete = () => {
    onDelete(id);
  };
  return (
    <React.Fragment>
      <tr className={`${even ? "even" : "odd"}`}>
        <td>{address}</td>
        <td className="text-center hides-content-to-operators">
          <DeleteIPRangeButton onClick={doIPRangeDelete} />
        </td>
      </tr>
    </React.Fragment>
  );
};
const IPRangesList = ({
  items = [],
  onDelete = doesNothing,
  onEdit = doesNothing,
}) => (
  <table className="table">
    <thead>
      <tr>
        <th>IP ADDRESSES TO BYPASS</th>
        <th className="text-center">ACTIONS</th>
      </tr>
    </thead>
    <tbody>
      {items
        .filter(({ deleted }) => deleted !== true)
        .map(({ __id, ...client }, index) => (
          <IPRangeItem
            id={__id}
            key={__id}
            {...client}
            even={(index + 1) % 2 === 0}
            onDelete={() => onDelete(__id)}
            onEdit={() => onEdit(__id)}
          />
        ))}
    </tbody>
  </table>
);
export default IPRangesList;
